import { render, staticRenderFns } from "./cargoInfo.vue?vue&type=template&id=c813240e&scoped=true"
import script from "./cargoInfo.vue?vue&type=script&lang=js"
export * from "./cargoInfo.vue?vue&type=script&lang=js"
import style0 from "./cargoInfo.vue?vue&type=style&index=0&id=c813240e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c813240e",
  null
  
)

export default component.exports